import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useCallback,
} from 'react';
import HttpService from '../../hooks/Https-services';
import { toast } from 'react-toastify';
import { API_ROUTES, hasRole, ROLE_IDS } from '../../utils/constant';
import { LoadingButton } from '@mui/lab';
import FullScreenDialog from '../FullScreenDialog';
import { GlobalSearchContext } from '../../context/GlobalSearchContext';
import useCommonDetails from '../../hooks/useCommonDetails';

function ClockInOut() {
  const {
    setIsCheckIn,
    isCheckIn,
    workElapsedTime,
    setWorkElapsedTime,
    loadingCheckOut,
    startTimer,
    stopTimer,
    breakElapsedTime,
    isBreakIn,
    setIsBreakIn,
    handleCheckIn,
    handleBreakIn,
    handleBreakOut,
    handleCheckOut,
    loadingBreakIn,
    loadingCheckIn,
    setLoadingCheckOut,
    loadingBreakOut,
  }: any = useContext(GlobalSearchContext);

  const currentUserInfo = useCommonDetails();
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    handleCheckOut();
  };

  const handleConfirmCheckOut = async () => {
    try {
      // Call the API to assign all games to another moderator
      const response = await HttpService.post(API_ROUTES.assignRequest);
    } catch (error) {
    } finally {
      handleCheckOut();
      setOpenDialog(false);
    }
  };

  const handleCheckOutClick = async () => {
    if (
      hasRole(currentUserInfo.roleId, [ROLE_IDS.MODERATOR]) &&
      currentUserInfo.teamId === 3
    ) {
      try {
        setLoadingCheckOut(true);
        const response = await HttpService.get(API_ROUTES.activeGameCount);
        const count = response.data.data;
        if (count.gameCounts > 0) {
          handleOpenDialog();
        } else {
          handleCheckOut();
        }
      } catch (error) {
        console.log('error:', error);
      } finally {
        setLoadingCheckOut(false);
      }
    } else {
      handleCheckOut();
    }
  };

  // Helper function to format elapsed time
  const formatElapsedTime = (milliseconds: number) => {
    const seconds = Math.floor((milliseconds / 1000) % 60);
    const minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
    const hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        borderRadius: 5,
        width: '380px',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {!isCheckIn ? (
        <LoadingButton
          size="small"
          color="warning"
          loading={loadingCheckIn}
          sx={{ borderRadius: 5 }}
          variant="contained"
          onClick={handleCheckIn}
        >
          Clock In
        </LoadingButton>
      ) : (
        <LoadingButton
          size="small"
          color="warning"
          loading={loadingCheckOut}
          sx={{ borderRadius: 5 }}
          disabled={isBreakIn}
          variant="contained"
          onClick={handleCheckOutClick}
        >
          Clock Out
        </LoadingButton>
      )}
      {!isBreakIn ? (
        <LoadingButton
          size="small"
          color="warning"
          loading={loadingBreakIn}
          sx={{ borderRadius: 5 }}
          variant="contained"
          disabled={!isCheckIn}
          onClick={handleBreakIn}
        >
          Break In
        </LoadingButton>
      ) : (
        <LoadingButton
          size="small"
          color="warning"
          loading={loadingBreakOut}
          sx={{ borderRadius: 5 }}
          variant="contained"
          onClick={handleBreakOut}
        >
          Break Out
        </LoadingButton>
      )}

      <Typography
        variant="subtitle1"
        sx={{
          color: 'black',
          padding: '0 !important',
          margin: '0 !important',
          lineHeight: '1 !important',
        }}
      >
        Work Time: {formatElapsedTime(workElapsedTime)}
        {isBreakIn && (
          <>
            <br /> Break Time: {formatElapsedTime(breakElapsedTime)}
          </>
        )}
      </Typography>

      <Dialog open={openDialog}>
        <DialogTitle>Confirm Clock Out</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You still have games assigned to you. Would you like to assign them
            to another moderator before clocking out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmCheckOut}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ClockInOut;
